export var TelemetryEventName;
(function (TelemetryEventName) {
    // Data contract
    TelemetryEventName["App_DSMS_DataContract_ParseError"] = "App_DSMS_DataContract_ParseError";
})(TelemetryEventName || (TelemetryEventName = {}));

//# sourceMappingURL=TelemetryEventName.js.map
